<app-titolo-subtitolo
  [titolo]="'Motivazione della scelta del campione'"
  [subTitolo]="
    'Motivare la scelta del campione coinvolto nella valutazione degli IRO per la categoria selezionata'
  "
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont">
  <div appFormContainer [larghezza]="3">
    <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
      <textarea
        matInput
        placeholder="Inserisci testo"
        [(ngModel)]="sceltaCampione"
        rows="4"
        [required]="obbligatorio"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-flat-button color="accent" class="accent-button" (click)="chiudi()">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
      Conferma
    </button>
  </div>
</div>
